export default __webpack_public_path__ + "static/media/driver_notSelected.cb9cf9db.svg";